import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Alert } from '@mui/material';
import { getRankings } from '../services/apiService';
import { toast } from 'react-toastify';

const RankingsPage = () => {
  const [rankings, setRankings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRankings = async () => {
      setIsLoading(true);
      setError('');
      try {
        const response = await getRankings();
        // Assuming API returns an array like:
        // [{ username: 'user1', sets_submitted: 10, sets_validated: 5 }, ...]
        setRankings(response.data || []);
      } catch (err) {
        console.error("Error fetching rankings:", err);
        const errMsg = err.response?.data?.error || 'Failed to load rankings.';
        setError(errMsg);
        toast.error(errMsg);
      } finally {
        setIsLoading(false);
      }
    };
    fetchRankings();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom>User Rankings</Typography>
       <Paper sx={{ p: 2 }}>
         {isLoading && <Box sx={{display: 'flex', justifyContent: 'center', p: 3}}><CircularProgress /></Box>}
         {error && <Alert severity="error">{error}</Alert>}
         {!isLoading && !error && rankings.length === 0 && <Typography sx={{textAlign: 'center', p: 3}}>No ranking data available yet.</Typography>}
         {!isLoading && !error && rankings.length > 0 && (
            <TableContainer>
              <Table stickyHeader aria-label="user rankings table">
                <TableHead>
                  <TableRow>
                    <TableCell>Rank</TableCell>
                    <TableCell>Username</TableCell>
                    <TableCell align="right">Annotation Sets Submitted</TableCell>
                    <TableCell align="right">Annotation Sets Validated</TableCell>
                    {/* Add more columns if API provides more metrics */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rankings.map((user, index) => (
                    <TableRow
                      key={user.username} // Assuming username is unique
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell>{user.username}</TableCell>
                      <TableCell align="right">{user.sets_submitted ?? 0}</TableCell>
                      <TableCell align="right">{user.sets_validated ?? 0}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
         )}
        </Paper>
    </Box>
  );
};

export default RankingsPage;
